// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
  filter: var(--shadow);
  position: relative;
  z-index: 20;
}

footer .eb {
  font-size: 20px;
  font-weight: 600;
}

footer a:not(.eb) {
  margin: 4px 0;
  white-space: pre-wrap; /* CSS3 */
  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
}

.footer-top {
  padding: 32px;
  background-color: var(--light);
  display: flex;
  justify-content: space-around;
}

.footer-column {
  display: flex;
  flex-direction: column;
  margin: 0 8px;
}

.footer-bottom {
  padding: 8px 16px;
  background-color: var(--dark);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-bottom i:not(.fa-compass),
.footer-bottom .cinzel,
.footer-bottom p,
.footer-bottom a {
  color: var(--light);
}

.footer-bottom i.fa-facebook {
  margin-left: 16px;
  font-size: 2.3rem;
}

.footer-bottom i.fa-envelope {
  font-size: 2.62rem;
}

.footer-bottom a.icon-link {
  display: flex;
  align-items: center;
  margin-right: 16px;
}

.footer-bottom p {
  font-size: 12px;
}

.footer-bottom p::before {
  content: "© Copyright " attr(data-date) ".";
}

footer .cinzel {
  font-size: 32px;
}

@media (max-width: 950px) {
  footer .Button {
    display: none;
  }
  .footer-bottom {
    padding: 8px;
  }

  .footer-bottom img:not(.footer-bottom img.iconSvg) {
    width: 35vw;
  }

  .footer-bottom img.iconSvg {
    width: 8vw;
  }

  .footer-bottom .fa-brands {
    margin-left: 4px !important;
  }
  .footer-bottom .cinzel {
    font-size: 20px !important;
  }
  .footer-bottom p {
    max-width: 101px;
    margin: 0;
    font-size: 12px;
    text-align: center;
  }
  .footer-bottom p::before {
    content: "";
  }
  .footer-top {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/Footer.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB,EAAE,SAAS;EAChC,0BAA0B,EAAE,wBAAwB;EACpD,sBAAsB,EAAE,cAAc;EACtC,wBAAwB,EAAE,YAAY;EACtC,qBAAqB,EAAE,2BAA2B;AACpD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["footer {\n  filter: var(--shadow);\n  position: relative;\n  z-index: 20;\n}\n\nfooter .eb {\n  font-size: 20px;\n  font-weight: 600;\n}\n\nfooter a:not(.eb) {\n  margin: 4px 0;\n  white-space: pre-wrap; /* CSS3 */\n  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */\n  white-space: -pre-wrap; /* Opera 4-6 */\n  white-space: -o-pre-wrap; /* Opera 7 */\n  word-wrap: break-word; /* Internet Explorer 5.5+ */\n}\n\n.footer-top {\n  padding: 32px;\n  background-color: var(--light);\n  display: flex;\n  justify-content: space-around;\n}\n\n.footer-column {\n  display: flex;\n  flex-direction: column;\n  margin: 0 8px;\n}\n\n.footer-bottom {\n  padding: 8px 16px;\n  background-color: var(--dark);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.footer-bottom i:not(.fa-compass),\n.footer-bottom .cinzel,\n.footer-bottom p,\n.footer-bottom a {\n  color: var(--light);\n}\n\n.footer-bottom i.fa-facebook {\n  margin-left: 16px;\n  font-size: 2.3rem;\n}\n\n.footer-bottom i.fa-envelope {\n  font-size: 2.62rem;\n}\n\n.footer-bottom a.icon-link {\n  display: flex;\n  align-items: center;\n  margin-right: 16px;\n}\n\n.footer-bottom p {\n  font-size: 12px;\n}\n\n.footer-bottom p::before {\n  content: \"© Copyright \" attr(data-date) \".\";\n}\n\nfooter .cinzel {\n  font-size: 32px;\n}\n\n@media (max-width: 950px) {\n  footer .Button {\n    display: none;\n  }\n  .footer-bottom {\n    padding: 8px;\n  }\n\n  .footer-bottom img:not(.footer-bottom img.iconSvg) {\n    width: 35vw;\n  }\n\n  .footer-bottom img.iconSvg {\n    width: 8vw;\n  }\n\n  .footer-bottom .fa-brands {\n    margin-left: 4px !important;\n  }\n  .footer-bottom .cinzel {\n    font-size: 20px !important;\n  }\n  .footer-bottom p {\n    max-width: 101px;\n    margin: 0;\n    font-size: 12px;\n    text-align: center;\n  }\n  .footer-bottom p::before {\n    content: \"\";\n  }\n  .footer-top {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
